<template>
  <div class="contant">
    <van-nav-bar :title="title" left-arrow @click-left="onClickLeft" />
    <div class="contant-box">
      <div class="box-title">设备认证注意事项</div>
      <div class="box-text">1：比如我A手机认证了，B手机再连接时，需要再次认证【认证完成后，比如在A卡槽认证后，切到B卡槽，要再次进行认证】</div>
      <div class="box-text" style="padding-bottom:10px;border-bottom:1px solid #F2F3F5">2：认证时，请正确填写设备MAC地址，随意填写无法正常上网</div>
      <div class="form-box">
        <div class="form-box-title">便携式设备MAC地址</div>
        <van-field v-model="form.mac" placeholder="请输入用户名" />
        <div class="form-box-title">联网终端设备MAC地址</div>
        <van-field v-model="form.terminalMac" placeholder="请输入手机号码" />
        <div class="form-box-title">手机号</div>
        <van-field v-model="form.phone" placeholder="请输入手机号" />
        <div class="form-box-title">验证码</div>
        <van-field v-model="form.verifyCode" placeholder="请输入验证码" >
          <template #button>
            <div style="font-size:13px;color:#3491FA" @click="sendCodeFn">{{text}}</div>
          </template>
        </van-field>
        <van-button  block type="info" size="small" native-type="submit" @click="confirmEquipmentFn">确认认证</van-button>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    phoneSimCard,
  } from "../api/cardOperation";
import {getEquipmentSms,confirmEquipment} from "../api/user";
export default {
  data() {
    return {
      title: "",
      text:"发送验证码",
      sendCode: false,
      form: {
       mac: "",
       terminalMac: "",
       phone: "",
       iccId: "",
       verifyCode: "",  
      }
    }
  },
   mounted() {
    this.title =  `设备号: ${this.$route.query.card}`;
    phoneSimCard().then((res) => {
        if (res.status) {
          this.form.iccId = res.data.iccId;
        } else {
          this.$notify({ type: "warning", message: `${res.msg}` });
        }
    });
  },
  methods: {
      onClickLeft() {
        this.$router.go(-1);
      },
      sendCodeFn(){
        if(!this.form.mac || !this.form.terminalMac || !this.form.phone){
          this.$notify({ type: "warning", message: `请正确填写信息` });
          return;
        }
        if(this.sendCode) return;
        this.sendCode = true;
        let time = 60;
        this.text = `${time}s后重新发送`;
        let timer = setInterval(()=>{
          time--;
          this.text = `${time}s后重新发送`;
          if(time <= 0){
            clearInterval(timer);
            this.text = "发送验证码";
            this.sendCode = false;
          }
        },1000)
        getEquipmentSms(this.form).then(res=>{
          if(res.status){
            this.$notify({ type: "success", message: `${res.msg}` });
          }else{
            this.$notify({ type: "warning", message: `${res.msg}` });
          }
        })
      },
      confirmEquipmentFn(){
        if(!this.form.mac || !this.form.terminalMac || !this.form.phone || !this.form.verifyCode){
          this.$notify({ type: "warning", message: `请正确填写信息` });
          return;
        }
        confirmEquipment(this.form).then(res=>{
          if(res.status){
            this.form={
              mac: "",
              terminalMac: "",
              phone: "",
              iccId: "",
              verifyCode: "",  
            }
            this.$notify({ type: "success", message: `${res.msg}` });
          }else{
            this.$notify({ type: "warning", message: `${res.msg}` });
          }
        })}
  }

}
</script>

<style lang="scss" scoped>
.van-button--info {
  background: linear-gradient(120deg, #3491FA, #AAD2FF, #6BB3FF, #9FD4FD) !important;
  border: none !important;
}
.van-cell{
  background:#F2F3F5 ;
  margin-bottom: 10px;
  padding: 5px 10px;
}
.contant{
  background: #f5f5f5;
  height: 100vh;
  text-align: left;
  .contant-box{
    margin: 10px;
    background: #fff;
    border-radius: 10px;
    padding: 10px;
    .box-title{
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .box-text{
      font-size: 13px;
      line-height: 1.5;
    }
    .form-box{
      margin-top: 10px;
      .form-box-title{
        font-size: 14px;
        margin-bottom: 10px;
      }
    }
  }
}

</style>